import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-lightbox",
  "use": "various-lightbox-usage",
  "viewBox": "0 0 29 28",
  "content": "<symbol viewBox=\"0 0 29 28\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-lightbox\"><path d=\"M2 3.999V26l22-.001V28H0V4l2-.001zM11 12v5h5v6H5V12h6zm17.031 0v11h-11v-6h5v-5h6zM16 .027v6h-5v5H5v-11h11zm12.031 0v11h-6v-5h-5v-6h11z\" fill=\"#e3000f\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol